import { nextTick } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import { ligarTransicoesDeTela } from './transicaoDeTela';
import { ligarVersaoNova } from './versaoNova';
import { criarHistoriaLimpa } from './enderecos/historiaLimpa';
import { guardarContaPrincipal } from './enderecos/conta';

const routes = [...dashboard.routes];

// Endereços limpos (06/10/2026): o roteador vê `/app/accounts/1/processos/27`
// e a barra mostra `/processos/27` — ver `enderecos/historiaLimpa.js` e
// docs/navegacao/README.md.
export const router = createRouter({
  history: criarHistoriaLimpa(createWebHistory()),
  routes,
});

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  // A conta dos endereços limpos é a principal da pessoa (06/10/2026).
  guardarContaPrincipal(accountId);

  // Endereço LIMPO aberto sem conta conhecida (primeira vez neste
  // navegador: conta "0") ou com uma conta guardada de outro login que a
  // pessoa não tem: a mesma tela, na conta dela. Só para o endereço limpo —
  // um link antigo de OUTRA conta (`/app/accounts/5/conversations/42`) não é
  // levado para a conversa 42 da conta da pessoa, que seria outra conversa.
  const enderecoLimpo = !(window.location.pathname || '').startsWith('/app/');
  const temAConta = accounts.some(
    a => String(a.id) === String(to.params.accountId)
  );
  if (
    to.params.accountId &&
    !temAConta &&
    accountId &&
    (String(to.params.accountId) === '0' || enderecoLimpo)
  ) {
    return next({
      name: to.name,
      params: { ...to.params, accountId: String(accountId) },
      query: to.query,
      hash: to.hash,
      replace: true,
    });
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
  // A tela que desliza no celular — ver `transicaoDeTela.js`.
  ligarTransicoesDeTela(router, () => nextTick());
  // Deploy com o app aberto: tela que não carrega recarrega na versão nova.
  ligarVersaoNova(router);
};

export default router;
